export const GMAIL = 'GMAIL';
export const HUBSPOT_HOSTED = 'HUBSPOT_HOSTED';
export const OUTLOOK = 'OUTLOOK';